import { captureException } from "@sentry/nextjs";

type TagKeys = "errorType" | "code";

export function handleSentryError(
  message: string,
  error: unknown,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  tags?: Partial<Record<TagKeys, any>>
) {
  try {
    captureException(new Error(message), {
      tags: {
        checkoutType: "express",
        ...tags,
      },
      extra: {
        error,
      },
    });
  } catch (sentryError) {
    console.error("Error capturing Sentry exception:", sentryError);
  }
}
